export const UPDATE_USER_LAT_LONG = 'UPDATE_USER_LAT_LONG'

export const SAVE_BOOKING_STATE = 'SAVE_BOOKING_STATE'
export const ERROR_REPORTED = 'ERROR_REPORTED'

// System actions
export const SET_EXPERIMENT = 'SET_EXPERIMENT'
export const UPDATE_APPLE_PAY_AVAILABLE = 'UPDATE_APPLE_PAY_AVAILABLE'
export const UPDATE_GOOGLE_PAY_AVAILABLE = 'UPDATE_GOOGLE_PAY_AVAILABLE'
export const DECLINE_NEWSLETTER_SUBSCRIPTION = 'DECLINE_NEWSLETTER_SUBSCRIPTION'

// Optimizely actions
export const SET_OPTIMIZELY_EXPERIMENT = 'SET_OPTIMIZELY_EXPERIMENT'

// Utm actions
export const SET_UTM = 'SET_UTM'

// Auth actions
export const ACCOUNT_INIT_COMPLETE = 'ACCOUNT_INIT_COMPLETE'
export const ACCOUNT_ACCESS_SHOW_LOGIN = 'ACCOUNT_ACCESS_SHOW_LOGIN'
export const ACCOUNT_ACCESS_SHOW_EMAIL_JOIN = 'ACCOUNT_ACCESS_SHOW_EMAIL_JOIN'
export const ACCOUNT_ACCESS_SHOW_REGISTER = 'ACCOUNT_ACCESS_SHOW_REGISTER'
export const ACCOUNT_ACCESS_SHOW_FORGOT_PASSWORD = 'ACCOUNT_ACCESS_SHOW_FORGOT_PASSWORD'
export const ACCOUNT_ACCESS_SET_MODE = 'ACCOUNT_ACCESS_SET_MODE'
export const SET_RECENTLY_USED_AIRPORT_CODE = 'SET_RECENTLY_USED_AIRPORT_CODE'
export const SAVE_CUSTOMER_SIGNATURE = 'SAVE_CUSTOMER_SIGNATURE'
export const DELETE_CUSTOMER_SIGNATURE = 'DELETE_CUSTOMER_SIGNATURE'
export const SYNC_USER_DETAILS = 'SYNC_USER_DETAILS'
export const GSI_SCRIPT_LOADED = 'GSI_SCRIPT_LOADED'

// Cart Actions
export const CART_EMPTY_CHANGE_PACKAGE = 'CART_EMPTY_CHANGE_PACKAGE'
export const CART_EMPTY = 'CART_EMPTY'
export const CART_CHANGE_OFFER_PACKAGE = 'CART_CHANGE_OFFER_PACKAGE'
export const CART_ADD_ORDER = 'CART_ADD_ORDER'
export const CART_PROCESS_START = 'CART_PROCESS_START'
export const CART_PROCESS_CANCEL = 'CART_PROCESS_CANCEL'
export const CART_PROCESS_SUCCESS = 'CART_PROCESS_SUCCESS'
export const CART_ORDER_PROCESS_FAILURE = 'CART_ORDER_PROCESS_FAILURE'
export const CART_PROCESS_FAILURE = 'CART_PROCESS_FAILURE'
export const CART_ADD_BEDBANK = 'CART_ADD_BEDBANK'
export const CART_RESET_ADDONS = 'CART_RESET_ADDONS'
export const CART_RESET_RESERVATION_DATES = 'CART_RESET_RESERVATION_DATES'
export const CART_SET_RESERVATION_DATES = 'CART_SET_RESERVATION_DATES'
export const CART_SET_FLIGHTS_AVAILABILITY = 'CART_SET_FLIGHTS_AVAILABILITY'
export const CART_UPDATE_RESERVATION = 'CART_UPDATE_RESERVATION'
export const CART_UPDATE_ALL_RESERVATIONS = 'CART_UPDATE_ALL_RESERVATIONS'
export const CART_REMOVE = 'CART_REMOVE'
export const UPDATE_PERSONALISE_GIFT_CARD_DATA = 'UPDATE_PERSONALISE_GIFT_CARD_DATA'
export const UPDATE_PAYMENT_SELECTION = 'UPDATE_PAYMENT_SELECTION'
export const UPDATE_INSTALMENT_PLAN = 'UPDATE_INSTALMENT_PLAN'
export const SET_LE_CREDIT_BALANCE = 'SET_LE_CREDIT_BALANCE'
export const TOGGLE_LE_CREDIT = 'TOGGLE_LE_CREDIT'
export const SET_BOOK_DATES_FOR_ORDER = 'SET_BOOK_DATES_FOR_ORDER'
export const SET_CHANGE_DATES_FOR_ORDER = 'SET_CHANGE_DATES_FOR_ORDER'
export const ACTIVATE_REBOOKING = 'ACTIVATE_REBOOKING'
export const SET_CHANGE_PACKAGE_FOR_ORDER = 'SET_CHANGE_PACKAGE_FOR_ORDER'
export const REMOVE_PROMO_CODE = 'REMOVE_PROMO_CODE'
export const APPLY_PROMO_CODE = 'APPLY_PROMO_CODE'
export const CREDIT_UPDATE = 'CREDIT_UPDATE'
export const UPDATE_DEPARTING_FLIGHT = 'UPDATE_DEPARTING_FLIGHT'
export const UPDATE_RETURNING_FLIGHT = 'UPDATE_RETURNING_FLIGHT'
export const UPDATE_FLIGHT_PRICE_BREAKDOWN = 'UPDATE_FLIGHT_PRICE_BREAKDOWN'
export const UPDATE_FLIGHT_JOURNEY_COSTS = 'UPDATE_FLIGHT_JOURNEY_COSTS'
export const UPDATE_FLIGHT_JOURNEY_COST_WITH_BOOKING_FEE = 'UPDATE_FLIGHT_JOURNEY_COST_WITH_BOOKING_FEE'
export const UPDATE_FLIGHT_JOURNEY_COST_WITH_SERVICE_FEE = 'UPDATE_FLIGHT_JOURNEY_COST_WITH_SERVICE_FEE'
export const UPDATE_FLIGHT_JOURNEY_COST_WITH_FLIGHTS_CREDIT_FEE = 'UPDATE_FLIGHT_JOURNEY_COST_WITH_FLIGHTS_CREDIT_FEE'
export const UPDATE_FLIGHT_JOURNEY_COST_WITH_ATOL_FEE = 'UPDATE_FLIGHT_JOURNEY_COST_WITH_ATOL_FEE'
export const UPDATE_BASE_PRICE_SNAPSHOT = 'UPDATE_BASE_PRICE_SNAPSHOT'
export const START_FLIGHT_CHECKOUT = 'START_FLIGHT_CHECKOUT'
export const RESET_FLIGHTS = 'RESET_FLIGHTS'
export const RESET_DEPARTING_FLIGHT = 'RESET_DEPARTING_FLIGHT'
export const RESET_RETURNING_FLIGHT = 'RESET_RETURNING_FLIGHT'
export const UPDATE_REFERRAL_CODE = 'UPDATE_REFERRAL_CODE'
export const UPDATE_PASSENGER_BAGGAGE = 'UPDATE_PASSENGER_BAGGAGE'
export const UPDATE_TWO_WAY_PASSENGER_BAGGAGE = 'UPDATE_TWO_WAY_PASSENGER_BAGGAGE'
export const RESET_CART_ORDER = 'RESET_CART_ORDER'
export const SET_CART_ORIGINAL_PACKAGE_ID = 'SET_CART_ORIGINAL_PACKAGE_ID'
export const CART_PACKAGE_UPSELL_SHOWN = 'CART_PACKAGE_UPSELL_SHOWN'
export const CART_ADD_GIFT_CARD = 'CART_ADD_GIFT_CARD'
export const CART_ADD_PAYMENT_BALANCE = 'CART_ADD_PAYMENT_BALANCE'
export const CART_SET_OFFER = 'CART_SET_OFFER'
export const CART_ADD_PACKAGE = 'CART_ADD_PACKAGE'
export const CART_UPDATE_RESERVATION_TYPE = 'CART_UPDATE_RESERVATION_TYPE'
export const CART_SET_CURRENCY = 'CART_SET_CURRENCY'
export const CART_INITIALISED = 'CART_INITIALISED'
export const CART_UPDATE_ACCOMMODATION_PRICE = 'CART_UPDATE_ACCOMMODATION_PRICE'
export const CART_UPDATE_FLIGHT_ORIGIN = 'CART_UPDATE_FLIGHT_ORIGIN'
export const CART_UPDATE_FLIGHT_DESTINATION = 'CART_UPDATE_FLIGHT_DESTINATION'
export const CART_UPDATE_OCCUPANCY = 'CART_UPDATE_OCCUPANCY'
export const CART_SET_GIFT = 'CART_SET_GIFT'
export const CART_UPDATE_GIFT_FORM = 'CART_UPDATE_GIFT_FORM'
export const CART_FETCH_TAX_BREAKDOWN = 'CART_FETCH_TAX_BREAKDOWN'
export const RESET_FLIGHT_SELECT = 'RESET_FLIGHT_SELECT'
export const FLIGHT_JOURNEY_COSTS_UPDATED = 'FLIGHT_JOURNEY_COSTS_UPDATED'
export const CART_SET_FLIGHTS_CREDIT_DATA = 'CART_SET_FLIGHTS_CREDIT_DATA'
export const UPDATE_DEPARTING_FLIGHT_SEGMENT_COST = 'UPDATE_DEPARTING_FLIGHT_SEGMENT_COST'
export const UPDATE_RETURNING_FLIGHT_SEGMENT_COST = 'UPDATE_RETURNING_FLIGHT_SEGMENT_COST'

// Cart experience actions
export const CART_SET_EXPERIENCE_ITEM = 'CART_SET_EXPERIENCE_ITEM'
export const CART_SET_EXPERIENCE_TRANSFER = 'CART_SET_EXPERIENCE_TRANSFER'
export const CART_REMOVE_EXPERIENCE_TRANSFER = 'CART_REMOVE_EXPERIENCE_TRANSFER'

// Checkout experience actions
export const CHECKOUT_UPDATE_EXPERIENCE_ITEM = 'CHECKOUT_UPDATE_EXPERIENCE_ITEM'

// Cart Insurance actions
export const ACCEPT_INSURANCE_QUOTE = 'ACCEPT_INSURANCE_QUOTE'
export const REJECT_INSURANCE_QUOTE = 'REJECT_INSURANCE_QUOTE'
export const RESET_CART_QUOTE = 'RESET_CART_QUOTE'
export const SET_INSURANCE_PRODUCT = 'SET_INSURANCE_PRODUCT'
export const SET_INSURANCE_TRAVELLERS = 'SET_INSURANCE_TRAVELLERS'
export const RESET_CART_INSURANCE = 'RESET_CART_INSURANCE'
export const SET_INSURANCE_ORDER = 'SET_INSURANCE_ORDER'

// Insurance actions
export const RESET_INSURANCE = 'RESET_INSURANCE'
export const UPDATE_INSURANCE_PAYMENT_ITEM = 'UPDATE_INSURANCE_PAYMENT_ITEM'

// Order actions
export const RESET_ORDER = 'RESET_ORDER'
export const UPDATE_CURRENT_ORDER = 'UPDATE_CURRENT_ORDER'
export const ADD_ORDERS = 'ADD_ORDERS'

// Offer actions
export const OFFERS_CLEAR = 'OFFERS_CLEAR'
export const OFFER_CALENDAR_RECOMMENDATIONS_CLEAR = 'OFFER_CALENDAR_RECOMMENDATIONS_CLEAR'
export const OFFER_SHARE_START = 'OFFER_SHARE_START'
export const OFFER_SHARE_COMPLETE = 'OFFER_SHARE_COMPLETE'
export const OFFER_SET_SEARCH_RESULT_METADATA = 'OFFER_SET_SEARCH_RESULT_METADATA'
export const OFFER_VIEWED = 'OFFER_VIEWED'
export const OFFER_UPDATE_PRICING_DATA = 'OFFER_UPDATE_PRICING_DATA'
export const BEDBANK_UPDATE_PRICING_DATA = 'BEDBANK_UPDATE_PRICING_DATA'
export const OFFER_UPDATE_AVAILABLE_RATES = 'OFFER_UPDATE_AVAILABLE_RATES'

// Bnbl modal actions
export const UPDATE_GIFTING_BNBL_MODAL = 'UPDATE_GIFTING_BNBL_MODAL'
export const INITIALISE_BNBL_MODAL = 'INITIALISE_BNBL_MODAL'
export const UPDATE_BNBL_NUMBER_OF_ROOMS = 'UPDATE_BNBL_NUMBER_OF_ROOMS'
export const UPDATE_BNBL_PACKAGE_VIEW = 'UPDATE_BNBL_PACKAGE_VIEW'

// API based actions
export const API_CALL = 'API_CALL'
export const API_CALL_FAILURE = 'API_CALL_FAILURE'
export const API_CALL_REQUEST = 'API_CALL_REQUEST'
export const API_CALL_SUCCESS = 'API_CALL_SUCCESS'

// Flight based actions
export const CLEAR_FLIGHT_RESULT = 'CLEAR_FLIGHT_RESULT'
export const UPDATE_FLIGHT_FILTERS = 'UPDATE_FLIGHT_FILTERS'
export const UPDATE_FLIGHTS_SORT = 'UPDATE_FLIGHTS_SORT'
export const FETCH_AIRPORTS = 'FETCH_AIRPORTS'
export const FETCH_POPULAR_AIRPORTS = 'FETCH_POPULAR_AIRPORTS'
export const SET_FLIGHTS_CREDIT_DATA = 'SET_FLIGHTS_CREDIT_DATA'
export const FETCH_FLIGHT_CREDIT_RESERVATION = 'FETCH_FLIGHT_CREDIT_RESERVATION'
export const FETCH_FLIGHT_DEALS = 'FETCH_FLIGHT_DEALS'
export const FETCH_FLIGHT_DEAL = 'FETCH_FLIGHT_DEAL'

// Analytics based actions
export const PAGE_VIEW = 'PAGE_VIEW'
export const CART_ADD_FLIGHT = 'CART_ADD_FLIGHT'
export const PRODUCT_CLICK_VIEW_DETAILS = 'PRODUCT_CLICK_VIEW_DETAILS'
export const TRANSACTION_COMPLETE = 'TRANSACTION_COMPLETE'
export const TRANSACTION_START = 'TRANSACTION_START'
export const TRANSACTION_UPDATE = 'TRANSACTION_UPDATE'
export const TRANSACTION_FAILURE = 'TRANSACTION_FAILURE'
export const TRANSACTION_EVENT = 'TRANSACTION_EVENT'
export const CHECKOUT_START = 'CHECKOUT_START'
export const CHECKOUT_UPDATE = 'CHECKOUT_UPDATE'
export const ATTEMPTED_INCOMPLETE_CHECKOUT = 'ATTEMPTED_INCOMPLETE_CHECKOUT'
export const MAP_PROPERTY_PIN_CLICK = 'MAP_PROPERTY_PIN_CLICK'
export const MAP_OFFER_INFO_CLICK = 'MAP_OFFER_INFO_CLICK'
export const MAP_PIN_OFFER_VIEW = 'MAP_PIN_OFFER_VIEW'
export const DEAL_VIDEO_PLAYED = 'DEAL_VIDEO_PLAYED'
export const DEAL_VIDEO_PAUSED = 'DEAL_VIDEO_PAUSED'
export const OFFER_PRODUCT_DETAIL_VIEW = 'OFFER_PRODUCT_DETAIL_VIEW'
export const PACKAGE_VIEW_MORE_DETAILS_CLICK = 'PACKAGE_VIEW_MORE_DETAILS_CLICK'
export const INITIALISE_SEARCH_SESSION_ID = 'INITIALISE_SEARCH_SESSION_ID'
export const SET_LERE_VERSION = 'SET_LERE_VERSION'
export const SET_OFFER_CHECK_IN_CHECK_OUT = 'SET_OFFER_CHECK_IN_CHECK_OUT'
export const SET_OFFER_LERE_INLINE_YMAL_IN_VIEW = 'SET_OFFER_LERE_INLINE_YMAL_IN_VIEW'
export const CLEAR_OFFER_CHECK_IN_CHECK_OUT = 'CLEAR_OFFER_CHECK_IN_CHECK_OUT'

// Calendar based actions
export const CLEAR_BOOKING_CALENDAR = 'CLEAR_BOOKING_CALENDAR'
export const UPDATE_CALENDAR_FLIGHT_PROVIDER = 'UPDATE_CALENDAR_FLIGHT_PROVIDER'
export const CALENDAR_UPDATE_PRICING_DATA = 'CALENDAR_UPDATE_PRICING_DATA'

// UI based actions
export const TOGGLE_CART_PACKAGES = 'TOGGLE_CART_PACKAGES'
export const TOGGLE_CART_PACKAGE_NIGHTS = 'TOGGLE_CART_PACKAGE_NIGHTS'
export const TOGGLE_CART_SIDEBAR = 'TOGGLE_CART_SIDEBAR'
export const MODAL_OPEN = 'MODAL_OPEN'
export const BOOKING_DATE_WARNING_MODAL_OPEN = 'BOOKING_DATE_WARNING_MODAL_OPEN'
export const ACCOMMODATION_PRICE_CHANGE_MODAL_OPEN = 'ACCOMMODATION_PRICE_CHANGE_MODAL_OPEN'
export const HOTEL_PRICE_CHANGE_MODAL_OPEN = 'HOTEL_PRICE_CHANGE_MODAL_OPEN'
export const BUNDLE_PRICE_CHANGE_MODAL_OPEN = 'BUNDLE_PRICE_CHANGE_MODAL_OPEN'
export const BEDBANK_PRICE_CHANGE_MODAL_OPEN = 'BEDBANK_PRICE_CHANGE_MODAL_OPEN'
export const BEDBANK_HOTEL_PRICE_CHANGE_MODAL_OPEN = 'BEDBANK_HOTEL_PRICE_CHANGE_MODAL_OPEN'
export const TOUR_V2_PRICE_CHANGE_MODAL_OPEN = 'TOUR_V2_PRICE_CHANGE_MODAL_OPEN'
export const JOURNEY_PRICE_CHANGE_MODAL_OPEN = 'JOURNEY_PRICE_CHANGE_MODAL_OPEN'
export const JOURNEY_SOLD_OUT_MODAL_OPEN = 'JOURNEY_SOLD_OUT_MODAL_OPEN'
export const CANT_PROCESS_ORDER_ONLINE_MODAL_OPEN = 'CANT_PROCESS_ORDER_ONLINE_MODAL_OPEN'
export const JOURNEY_COST_CHANGE_MODAL_OPEN = 'JOURNEY_COST_CHANGE_MODAL_OPEN'
export const FLIGHTS_SESSION_EXPIRED_MODAL_OPEN = 'FLIGHTS_SESSION_EXPIRED_MODAL_OPEN'
export const TRAVELLER_NAME_TOO_LONG_MODAL_OPEN = 'TRAVELLER_NAME_TOO_LONG_MODAL_OPEN'
export const GENERIC_ORDER_ERROR_MODAL_OPEN = 'GENERIC_ORDER_ERROR_MODAL_OPEN'
export const AUTH_MODAL_OPEN = 'AUTH_MODAL_OPEN'
export const QUOTE_EMAIL_MODAL_OPEN = 'QUOTE_EMAIL_MODAL_OPEN'
export const MODAL_CLOSE = 'MODAL_CLOSE'
export const ACCOUNT_ACCESS_SHOW_PARTNERSHIP_LINK = 'ACCOUNT_ACCESS_SHOW_PARTNERSHIP_LINK'
export const SHOW_BRIDGER_PAY_PAYMENT_MODAL = 'SHOW_BRIDGER_PAY_PAYMENT_MODAL'
export const ADD_PAYMENT_PROVIDER = 'ADD_PAYMENT_PROVIDER'
export const SHOW_USE_GIFT_CARD_MODAL = 'SHOW_USE_GIFT_CARD_MODAL'
export const SHOW_CHANGE_DATE_WARNING_MODAL = 'SHOW_CHANGE_DATE_WARNING_MODAL'
export const SHOW_CHANGE_DATE_ADDON_WARNING_MODAL = 'SHOW_CHANGE_DATE_ADDON_WARNING_MODAL'
export const SHOW_BRIDGERPAY_PAYMENT_FAILED_MODAL = 'SHOW_BRIDGERPAY_PAYMENT_FAILED_MODAL'
export const SHOW_ACCOUNT_TAKE_OVER_MODAL = 'SHOW_ACCOUNT_TAKE_OVER_MODAL'
export const SHOW_FLIGHT_REBOOKING_CONDITIONS_MODAL = 'SHOW_FLIGHT_REBOOKING_CONDITIONS_MODAL'
export const ACCOUNT_DROPDOWN_TOGGLE = 'ACCOUNT_DROPDOWN_TOGGLE'
export const ACCOUNT_DROPDOWN_TOGGLE_STANDALONE = 'ACCOUNT_DROPDOWN_TOGGLE_STANDALONE'
export const REGION_DROPDOWN_TOGGLE = 'REGION_DROPDOWN_TOGGLE'
export const EVENTS_DROPDOWN_TOGGLE = 'EVENTS_DROPDOWN_TOGGLE'
export const PHONE_DROPDOWN_TOGGLE = 'PHONE_DROPDOWN_TOGGLE'
export const CLOSE_SOCIAL_WIDGET = 'CLOSE_SOCIAL_WIDGET'
export const SHOW_CUSTOMER_SIGNATURE_MODAL = 'SHOW_CUSTOMER_SIGNATURE_MODAL'
export const SHOW_CHECKOUT_CART_MODE_MODAL = 'SHOW_CHECKOUT_CART_MODE_MODAL'
export const SHOW_PAY_TO_AUTHORISATION_MODAL = 'SHOW_PAY_TO_AUTHORISATION_MODAL'

// Temp url params based actions
export const SET_PREFILL_QFF_NUMBER = 'SET_PREFILL_QFF_NUMBER'

// Content actions
export const DISMISS_NOTIFICATION_BANNER = 'DISMISS_NOTIFICATION_BANNER'

// BedbankOffer actions
export const BEDBANK_OFFER_PRODUCT_DETAIL_VIEW = 'BEDBANK_OFFER_PRODUCT_DETAIL_VIEW'
export const TOUR_V2_OFFER_PRODUCT_DETAIL_VIEW = 'TOUR_V2_OFFER_PRODUCT_DETAIL_VIEW'
export const TOUR_V2_OFFER_VARIATION_VIEW = 'TOUR_V2_OFFER_VARIATION_VIEW'

// Cruise actions
export const SAVE_CABIN_OPTION = 'SAVE_CABIN_OPTION'
export const RESTORE_CABIN_OPTION = 'RESTORE_CABIN_OPTION'
export const RESET_REVELEX_CALLS = 'RESET_REVELEX_CALLS'
export const RESET_CABIN_AVAILABILITY = 'RESET_CABIN_AVAILABILITY'
export const CRUISE_IN_FLOW_CHECKOUT_STEP = 'CRUISE_IN_FLOW_CHECKOUT_STEP'
export const CRUISE_SET_SEARCH_FACETS = 'CRUISE_SET_SEARCH_FACETS'
export const CRUISE_SET_CRUISE_LINES = 'CRUISE_SET_CRUISE_LINES'

// Checkout actions
export const CHECKOUT_INITIALISE = 'CHECKOUT_INITIALISE'
export const CHECKOUT_RESTORE_CART = 'CHECKOUT_RESTORE_CART'
export const CHECKOUT_REMOVE_TRAVELLER_SCHEMA = 'CHECKOUT_REMOVE_TRAVELLER_SCHEMA'
export const CHECKOUT_RESTORE_ABANDONED_CART = 'CHECKOUT_RESTORE_ABANDONED_CART'
export const CHECKOUT_APPLY_ABANDONED_CART = 'CHECKOUT_APPLY_ABANDONED_CART'
export const CHECKOUT_RESTORE_FORM = 'CHECKOUT_RESTORE_FORM'
export const CHECKOUT_RESET_FORM = 'CHECKOUT_RESET_FORM'
export const CHECKOUT_RESTORE_PAYMENT = 'CHECKOUT_RESTORE_PAYMENT'
export const CHECKOUT_UPDATE_ITEM = 'CHECKOUT_UPDATE_ITEM'
export const CHECKOUT_ADD_ITEM = 'CHECKOUT_ADD_ITEM'
export const CHECKOUT_REMOVE_ITEM = 'CHECKOUT_REMOVE_ITEM'
export const CHECKOUT_SET_FORM = 'CHECKOUT_SET_FORM'
export const CHECKOUT_EDIT_FORM = 'CHECKOUT_EDIT_FORM'
export const CHECKOUT_PROCESS_START = 'CHECKOUT_PROCESS_START'
export const CHECKOUT_PROCESS_CANCEL = 'CHECKOUT_PROCESS_CANCEL'
export const CHECKOUT_PROCESS_SUCCESS = 'CHECKOUT_PROCESS_SUCCESS'
export const CHECKOUT_PROCESS_FAILURE = 'CHECKOUT_PROCESS_FAILURE'
export const CHECKOUT_UPDATE_PAYMENT_SELECTION = 'CHECKOUT_UPDATE_PAYMENT_SELECTION'
export const CHECKOUT_UPDATE_INSTALMENT_PLAN = 'CHECKOUT_UPDATE_INSTALMENT_PLAN'
export const CHECKOUT_SET_INSURANCE_FETCH_PARAMETERS = 'CHECKOUT_SET_INSURANCE_FETCH_PARAMETERS'
export const CHECKOUT_SET_BOOKING_PROTECTION_SELECTED = 'CHECKOUT_SET_BOOKING_PROTECTION_SELECTED'
export const CHECKOUT_FETCHING_PROMO_CODE = 'CHECKOUT_FETCHING_PROMO_CODE'
export const CHECKOUT_APPLY_PROMO_CODE = 'CHECKOUT_APPLY_PROMO_CODE'
export const CHECKOUT_APPLY_PROMO_CODE_FAILED = 'CHECKOUT_APPLY_PROMO_CODE_FAILED'
export const CHECKOUT_RESET_PROMO_CODE = 'CHECKOUT_RESET_PROMO_CODE'
export const CHECKOUT_RESET_FLIGHT_ITEMS = 'CHECKOUT_RESET_FLIGHT_ITEMS'
export const CHECKOUT_UPDATE_FLIGHT_TOTAL_FARE = 'CHECKOUT_UPDATE_FLIGHT_TOTAL_FARE'
export const CHECKOUT_CLEAR_CART_RESTORE_PRICE = 'CHECKOUT_CLEAR_CART_RESTORE_PRICE'
// These are just alternate versions of the Qantas actions above, for the new checkout state
export const CHECKOUT_APPLY_VELOCITY_BURN = 'CHECKOUT_APPLY_VELOCITY_BURN'
export const CHECKOUT_CLEAR_VELOCITY_BURN = 'CHECKOUT_CLEAR_VELOCITY_BURN'
export const CHECKOUT_SET_VELOCITY_BURN_MODAL_STATUS = 'CHECKOUT_SET_VELOCITY_BURN_MODAL_STATUS'
export const CHECKOUT_APPLY_PARTNERSHIP_STATUS = 'CHECKOUT_APPLY_PARTNERSHIP_STATUS'
export const CHECKOUT_SET_SPECIAL_REQUEST = 'CHECKOUT_SET_SPECIAL_REQUEST'
export const CHECKOUT_SET_CONNECT_ROOMS_SPECIAL_REQUEST = 'CHECKOUT_SET_CONNECT_ROOMS_SPECIAL_REQUEST'
export const CHECKOUT_SET_ROOMS_TO_BE_CONNECTED = 'CHECKOUT_SET_ROOMS_TO_BE_CONNECTED'
export const CHECKOUT_TOGGLE_CREDIT = 'CHECKOUT_TOGGLE_CREDIT'
export const CHECKOUT_UPDATE_FLIGHT_ITEM_PAX_BAGGAGE = 'CHECKOUT_UPDATE_FLIGHT_ITEM_PAX_BAGGAGE'
export const CHECKOUT_SHOW_PROMO_CORPORATE_BENEFITS = 'CHECKOUT_SHOW_PROMO_CORPORATE_BENEFITS'
export const CHECKOUT_HIDE_PROMO_CORPORATE_BENEFITS = 'CHECKOUT_HIDE_PROMO_CORPORATE_BENEFITS'
export const CHECKOUT_SHOW_PROMO_FRIENDS_AND_FAMILY = 'CHECKOUT_SHOW_PROMO_FRIENDS_AND_FAMILY'
export const CHECKOUT_HIDE_PROMO_FRIENDS_AND_FAMILY = 'CHECKOUT_HIDE_PROMO_FRIENDS_AND_FAMILY'
export const CHECKOUT_SET_RESTORE_CART_STATUS = 'CHECKOUT_SET_RESTORE_CART_STATUS'
export const CHECKOUT_MODIFY_FLIGHT_SEARCH_VIEW = 'CHECKOUT_MODIFY_FLIGHT_SEARCH_VIEW'
export const CHECKOUT_SET_POST_PURCHASE = 'CHECKOUT_SET_POST_PURCHASE'
export const CHECKOUT_UPDATE_HOTEL_ITEM_PRICING = 'CHECKOUT_UPDATE_HOTEL_ITEM_PRICING'
export const CHECKOUT_UPDATE_BUNDLE_ITEM_PRICING = 'CHECKOUT_UPDATE_BUNDLE_ITEM_PRICING'
export const CHECKOUT_SET_DEV_TOOLS_ENABLED = 'CHECKOUT_SET_DEV_TOOLS_ENABLED'
export const CHECKOUT_CLEAR_CART = 'CHECKOUT_CLEAR_CART'
export const CHECKOUT_LINK_VELOCITY_FREQUENT_FLYER = 'CHECKOUT_LINK_VELOCITY_FREQUENT_FLYER'
export const CHECKOUT_UPDATE_ARRIVAL_FLIGHT_NUMBER = 'UPDATE_ARRIVAL_FLIGHT_NUMBER'
export const CHECKOUT_AGENT_BOOKING_DETAILS = 'CHECKOUT_AGENT_BOOKING_DETAILS'
export const CHECKOUT_UPDATE_CAR_HIRE_ADDONS = 'CHECKOUT_UPDATE_CAR_HIRE_ADDONS'
export const CHECKOUT_DELETE_CAR_HIRE_ADDONS = 'CHECKOUT_DELETE_CAR_HIRE_ADDONS'
export const CHECKOUT_SELECT_NO_INSURANCE = 'CHECKOUT_SELECT_NO_INSURANCE'
export const CHECKOUT_REMOVE_EARN_VELOCITY_FREQUENT_FLYER = 'CHECKOUT_REMOVE_EARN_VELOCITY_FREQUENT_FLYER'
export const CHECKOUT_SET_MULTI_CART_ITEM_MODE = 'CHECKOUT_SET_MULTI_CART_ITEM_MODE'
export const CHECKOUT_ADD_CAR_HIRE_INSURANCE = 'CHECKOUT_ADD_CAR_HIRE_INSURANCE'
export const CHECKOUT_SET_MERCHANT_FEE_PAYMENT_TYPE = 'CHECKOUT_SET_MERCHANT_FEE_PAYMENT_TYPE'

// Genesys custom events actions
export const GENESYS_CUSTOM_EVENT = 'GENESYS_CUSTOM_EVENT'
export const GENESYS_SEARCH_EVENT = 'GENESYS_SEARCH_EVENT'
export const OPEN_CHAT_WINDOW = 'OPEN_CHAT_WINDOW'

// Experience Actions
export const EXPERIENCE_VIEWED = 'EXPERIENCE_VIEWED'
export const SET_EXPERIENCE_PLACE = 'SET_EXPERIENCE_PLACE'
// Navigation actions
export const PATH_CHANGE = 'PATH_CHANGE'

// Tour traveller details actions
export const TOUR_TRAVELLER_DETAILS_RESET_SUBMISSION = 'TOUR_TRAVELLER_DETAILS_RESET_SUBMISSION'

// User reviews
export const USER_REVIEW_SET_PHOTO_UPLOAD_PERCENTAGE = 'USER_REVIEW_SET_PHOTO_UPLOAD_PERCENTAGE'
export const USER_REVIEW_SET_REVIEW_STAGE = 'USER_REVIEW_SET_REVIEW_STAGE'

// Velocity Auth
export const CHECKOUT_SET_VELOCITY_SSO = 'CHECKOUT_SET_VELOCITY_SSO'

// Sticky prompt card
export const ENABLE_STICKY_PROMPT_CARD = 'ENABLE_STICKY_PROMPT_CARD'
export const DISABLE_STICKY_PROMPT_CARD = 'DISABLE_STICKY_PROMPT_CARD'

export const CHECKOUT_UPDATE_CS_DEPOSIT_OVERRIDE = 'CHECKOUT_UPDATE_CS_DEPOSIT_OVERRIDE'

// LERE actions
export const LERE_SAVE_HOT_LEADS = 'LERE_SAVE_HOT_LEADS'
export const LERE_REMOVE_HIGH_INTENT = 'LERE_REMOVE_HIGH_INTENT'
export const LERE_SAVE_ABANDONED_CART = 'LERE_SAVE_ABANDONED_CART'
export const LERE_DISMISS_STICKY_ABANDONED_CART = 'LERE_DISMISS_STICKY_ABANDONED_CART'
export const LERE_DISMISS_ALL_STICKY_ABANDONED_CART = 'LERE_DISMISS_ALL_STICKY_ABANDONED_CART'
export const LERE_REMOVE_ABANDONED_CART = 'LERE_REMOVE_ABANDONED_CART'
export const LERE_DISMISS_USER_PREFERENCES_NOTIFICATION = 'DISMISS_LERE_USER_PREFERENCES_NOTIFICATION'
export const LERE_HAS_DISMISSED_USER_PREFERENCES_NOTIFICATION = 'HAS_DISMISSED_LERE_USER_PREFERENCES_NOTIFICATION'

// Booking Protection
export const SET_BOOKING_PROTECTION_INVALID = 'SET_BOOKING_PROTECTION_INVALID'

// Loyalty actions
export const CLEAR_LOYALTY_MEMBER_SUBSCRIPTION = 'CLEAR_LOYALTY_MEMBER_SUBSCRIPTION'

// Agent hub
export const SET_CUSTOMER_VIEW_TOGGLE = 'SET_CUSTOMER_VIEW_TOGGLE'
